// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import LazyImage, { LazyImageProps } from "@stoneage/MobiusOverrides/LazyImage";
import Tooltip, { TooltipPresentationProps } from "@stoneage/MobiusOverrides/Tooltip/Tooltip";
import React, { useState } from "react";

interface Props {
    url?: string;
    tooltipText: string;
    extendedStyles?: JettingAppImageStyles;
}

export interface JettingAppImageStyles {
    image?: LazyImageProps;
    tooltip?: TooltipPresentationProps;
}

export const jettingAppImageStyles: JettingAppImageStyles = {};

const JettingAppImage = ({ extendedStyles, url, tooltipText }: Props) => {
    const [styles] = useState(() => mergeToNew(jettingAppImageStyles, extendedStyles));

    const notFoundImagePath = useAppSelector(
        state => (getSettingsCollection(state).customSettings as any).cloudinaryGlobalNotFoundImagePath,
    );

    return <LazyImage title={tooltipText} disableLazyLoad src={url || notFoundImagePath} {...styles.image} />;
};
export default JettingAppImage;
